var ProductJsNew = function( item, product, isQuickView ) {
  var optionsMap = {};
  var optionsMapAll = {};
  var productJs = this;
  var stickyATC = $('#stickyATC');
  var mobileStickyAtc = $('#sticky-atc');

	var productOptions = product.options.map(function(e){return e.toLowerCase()});
  var productGallerySwiper;
  var quickViewSwiper;
  var variantTextReplacementMetafield = document.querySelector('.main-product__item').getAttribute('data-words-to-be-removed-from-variant-title') ? document.querySelector('.main-product__item').getAttribute('data-words-to-be-removed-from-variant-title').split(",") : undefined;
  var variantAlreadySelected = false;
  var initSwiper = false;
  var initZoomSwiper = false;


  productJs.config = {
    gallery:{
      galleryGroupByOptions: 'drawer size, mat size, fabric color, top color, seat color, frame color, desk color, leg color, chair color, stand color, cord color, color, orientation, seat, power, tray, tray color, panel type, desk size, chair/headrest color, accessories color, style, base color, configuration, height, back, sleeve size, condition, hardware color, board size, stand size, tray size, shelf size, design, color & material, cabinet drawers, model'.split(',').map(function(s) { return s.trim() }).filter(function(v){return v!=='' && productOptions.indexOf(v)>-1}),
      galleryGroupMatchMode: '4' //1 Match Everything, 2 Match Any, 4 Exclusive OR  
    }
  };

  var init = function() {
    if(!item.hasClass('initialized')) {
      
      item.data('productjs', productJs);
      initVariantStatus();
      initializeVariantSelector();

      item.addClass('initialized');
      window.Branch.product.formatSwatches();
      window.Branch.product.resizeSwatchesHeader(`.main-product`);
      window.Branch.product.customSwatchContainerResize(`.main-product`);
      window.Branch.product.initAccordion();

      window.Branch.product.initSwatchClickListener(product, isQuickView, 'main-product');
      let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;

      if(isQuickView) { 
        window.Branch.product.initOkendoStarRendering(true);
        let mainProductHideSingle = document.querySelector('.main-product[data-quick-view="false"] .swatches-container') && document.querySelector('.main-product[data-quick-view="false"] .swatches-container').getAttribute('data-hide-single-option-size-swatches') == 'true' ? true : false;
        if(mainProductHideSingle){
          document.querySelector('.main-product[data-quick-view="true"] .swatches-container').setAttribute('data-hide-single-option-size-swatches', true)
        }
        
        setTimeout(() => {
          window.Branch.product.formatPreOrderSwatch(product.id);
        }, 1000)
      }
    }
  };

  var initVariantStatus = function() {
    $.each(product.variants, function(key, variant){
      //AVAILABLE
      if(variant.available) {
        variant.status = 'available';
      } else {
        //SOLDOUT
        variant.status = 'soldout';
      }
    });
  };

    

    productJs.filterThumbs = function(objectOptions, optionsContainer, gallery, allow_image_filtering_by_size) {
      //Example reference:
      //objectOptions: product.options
      //optionsContainer: variant;
      //gallery: jQuery object of the gallery, ex. $('.thumbs'), $('.main-product-gallery__inner-container'), etc.

      var galleryOptions = productJs.config.gallery;
      var groupOptionProperties = [];

      if(allow_image_filtering_by_size){
        galleryOptions.galleryGroupByOptions.push('size');
      }

      $(galleryOptions.galleryGroupByOptions).each(function (ix, e){
        $(objectOptions).each(function(ix2,e2){
          if (Simplistic.handleize(e) == Simplistic.handleize(e2))
            groupOptionProperties.push('option'+(1+ix2))
        })
      })
      
      if(groupOptionProperties.length>0) {
        gallery.find('.slideVisible').addClass('visibility-transition').removeClass('slideVisible');

        var slideSelector = '';
        // var nextVariantSlideSelector = '';

        let addonsVariants = document.querySelector('.main-product .addons-variants #addon-products-for-atc') && document.querySelector('.main-product .addons-variants #addon-products-for-atc').getAttribute('value') ? JSON.parse(document.querySelector('.main-product .addons-variants #addon-products-for-atc').getAttribute('value')) : [];
        const nonSelectedAddOnOptions = [...document.querySelectorAll('.main-product .addons-variants .item.disabled')].map(item => item.getAttribute('data-addon-handle'));

        const updateSelectorForAddonOnSpecificImages = function(selector, addonsVariants, nonSelectedAddOnOptions){
          let newSelector = `${selector}`;
          if(addonsVariants.length == 0){
            newSelector = `${newSelector}:not([data-included-addon-handle])`;
          } else {
            addonsVariants.forEach((addonsVariant) => {
              newSelector = `${newSelector}:not([data-excluded-addon-handle="_${addonsVariant.productHandle}_"])`;
            });
            nonSelectedAddOnOptions.forEach((nonSelectedAddOn) => {
              newSelector = `${newSelector}:not([data-included-addon-handle="_${nonSelectedAddOn}_"])`;
            })
          }
          return newSelector;
        }

        $(groupOptionProperties).each(function(ix,e){
          var part1Selector = '';
          var part2Selector = '';

          // var nextVariantPart1Selector = '';
          // var nextVariantPart2Selector = '';

          if(slideSelector=='' || galleryOptions.galleryGroupMatchMode>=2)
            part1Selector += ' .main-product-gallery__item';
          // nextVariantPart1Selector += ' .main-product-gallery__item';

          // console.log('ix', ix, 'e', e);
          // console.log('objectOptions', objectOptions);



          part1Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix])+'*="_'+Simplistic.handleize(optionsContainer[e])+'_"]';
        //  console.log('galleryOptions.galleryGroupByOptions', galleryOptions.galleryGroupByOptions)
        //  console.log('optionsContainer', optionsContainer)
        //  nextVariantPart1Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix])+'*="_'+Simplistic.handleize(optionsContainer[e])+'_"]';
          if (galleryOptions.galleryGroupMatchMode==4) {
            part2Selector = ', ' +part1Selector;
            // nextVariantPart2Selector = ', ' +nextVariantPart1Selector;
            $(groupOptionProperties).each(function(ix2,e2){
              if (e2!=e) {
                part1Selector += ':not([data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'])';
                part2Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'*="_'+Simplistic.handleize(optionsContainer[e2])+'_"]';

                // nextVariantPart1Selector += ':not([data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'])';
                // nextVariantPart2Selector += '[data-'+Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix2])+'*="_'+Simplistic.handleize(optionsContainer[e2])+'_"]';


              }
            });
          }

          part1Selector = updateSelectorForAddonOnSpecificImages(part1Selector, addonsVariants, nonSelectedAddOnOptions)
          part2Selector = updateSelectorForAddonOnSpecificImages(part2Selector, addonsVariants, nonSelectedAddOnOptions)

          // console.log('slideSelector', slideSelector)

          slideSelector += (slideSelector=='' || galleryOptions.galleryGroupMatchMode==1 ? '' : ', ') + part1Selector + part2Selector;
            // nextVariantSlideSelector += (nextVariantSlideSelector=='' || galleryOptions.galleryGroupMatchMode==1 ? '' : ', ') + nextVariantPart1Selector + nextVariantPart2Selector;
        });

        //Show the images that don't have any of the galleryGroupByOptions
        var withoutAltSelector = ' .main-product-gallery__item';
        $(galleryOptions.galleryGroupByOptions).each(function(){
          withoutAltSelector += ':not([data-'+Simplistic.handleize(this)+'])';
          withoutAltSelector =  updateSelectorForAddonOnSpecificImages(withoutAltSelector, addonsVariants, nonSelectedAddOnOptions)
        });
        slideSelector += ', ' + withoutAltSelector;
        // nextVariantSlideSelector += ', ' + withoutAltSelector;

        var sortCompare = function(a,b){
            akey = parseInt($(a).attr("data-index"));
            bkey = parseInt($(b).attr("data-index"));
            if (akey == bkey) return 0;
            if (akey < bkey) return -1;
            if (akey > bkey) return 1;
        };


        gallery.find(slideSelector).sortDomElements(sortCompare).addClass('slideVisible');

        // Partial matching: find items where all their specified attributes match the variant
        gallery.find('.main-product-gallery__item:not(.slideVisible)').each(function(){
          var $item = $(this);
          var allAttributesMatch = true;
          var hasAnyAttribute = false;

          // Build variant option values for comparison
          var variantOptions = {};
          $(groupOptionProperties).each(function(ix, e){
            var optionName = Simplistic.handleize(galleryOptions.galleryGroupByOptions[ix]);
            var optionValue = '_' + Simplistic.handleize(optionsContainer[e]) + '_';
            variantOptions[optionName] = optionValue;
          });

          // Check each groupByOption to see if item has it and if it matches
          for (var i = 0; i < galleryOptions.galleryGroupByOptions.length; i++) {
            var optionName = Simplistic.handleize(galleryOptions.galleryGroupByOptions[i]);
            var itemValue = $item.attr('data-' + optionName);

            if (itemValue) {
              hasAnyAttribute = true;
              if (itemValue !== variantOptions[optionName]) {
                allAttributesMatch = false;
                break;
              }
            }
          }

          // If item has at least one attribute and all match, show it
          if (hasAnyAttribute && allAttributesMatch) {
            // Check addon filtering
            var passesAddonFilter = true;
            if (addonsVariants.length == 0) {
              if ($item.attr('data-included-addon-handle')) {
                passesAddonFilter = false;
              }
            } else {
              for (var j = 0; j < addonsVariants.length; j++) {
                if ($item.attr('data-excluded-addon-handle') === '_' + addonsVariants[j].productHandle + '_') {
                  passesAddonFilter = false;
                  break;
                }
              }
              for (var k = 0; k < nonSelectedAddOnOptions.length; k++) {
                if ($item.attr('data-included-addon-handle') === '_' + nonSelectedAddOnOptions[k] + '_') {
                  passesAddonFilter = false;
                  break;
                }
              }
            }

            if (passesAddonFilter) {
              $item.addClass('slideVisible');
            }
          }
        });

        gallery.find('.slideVisible').sortDomElements(sortCompare);
        gallery.find('.visibility-transition').removeClass('visibility-transition');

        /* Start of code to restore after product gallery test is over */

        // gallery.find('.main-product-gallery__item[data-hide-from-test-gallery="true"]').removeClass('slideVisible');
        
        /* End of code to restore after product gallery test is over */



        /* Start of code to delete after product gallery test is over */

        // Check if smart-gallery-test element exists with specific attributes
        var smartGalleryTest = document.getElementById('smart-gallery-test');
        if (smartGalleryTest &&
            smartGalleryTest.getAttribute('data-test-active') === 'false' &&
            smartGalleryTest.getAttribute('control-variant') === '1') {
            // Remove slideVisible from items with data-hide-from-legacy-gallery="true"
            gallery.find('.main-product-gallery__item[data-hide-from-legacy-gallery="true"]').removeClass('slideVisible');
        } else {
            // Remove slideVisible class from items with data-hide-from-test-gallery="true"
            gallery.find('.main-product-gallery__item[data-hide-from-test-gallery="true"]').removeClass('slideVisible');
        }

        /* End of code to delete after product gallery test is over */



      }else{
        gallery.find('.main-product-gallery__item').addClass('slideVisible');
      }

      // PDP UGC surfaces test: both branches above hand slideVisible back out, so the "Styled By
      // You" slides have to be re-hidden here whenever data-pdp-ugc isn't set to "gallery".
      if(window.Branch.productGallery.applyUgcTestToGallerySlides) {
        window.Branch.productGallery.applyUgcTestToGallerySlides();
      }

      if(gallery.parent().hasClass('swiper-initialized')) {
        // if(gallery.closest('.main-product__item').attr('data-quick-view') == "false"){
        //   productGallerySwiper.slideTo(0);
        // } else {
        //   quickViewSwiper.slideTo(0)
        // }
      } else {
        gallery.find('.slideVisible').each(function(key, object){
          if(gallery.find('.slideVisible').size() <=3 || $(this).hasClass('is-video')){
            $(this).addClass('whole');
          }else{
            
          }
        });
      }
      let quickViewAddonGallery = document.querySelector(`.main-product .main-product__item[data-quick-view="true"] .main-product-gallery[data-product-id="${product.id}"]`)
      if(quickViewAddonGallery && quickViewAddonGallery.getAttribute('data-initial-variant-selected') !== 'true'){
        setTimeout(function(){
          quickViewAddonGallery.setAttribute('data-initial-variant-selected', true);
        }, 500)
    }
    }

    var initializeVariantSelector = function() {
      var variantSelectorId = "product-select-"+product.id;
      var selectCallback = onVariantSelected();


      new Shopify.OptionSelectors(variantSelectorId, { product: product, onVariantSelected: selectCallback });

      if(product.options.length > 1) {
        if(product.variants.length > 1) {
          linkOptionSelectors(product);
        }

        // Add label if only one product option and it isn't 'Title'.
        if(product.options.length == 1 && product.options[0] != 'Title') {
          item.find('.selector-wrapper:eq(0)').prepend('<label>'+product.options[0]+'</label>');
        }

        item.find('.selector-wrapper label').append(':');
      } else {
        if(product.variants.length > 1) {
          item.find('.select-variant').change(function(){
            var variantSelected = false;
            $.each(product.variants, function(key, variant){
              if(variant.id==item.find('.select-variant').val()) {
                variantSelected = variant;
                return;
              }
            });
            selectCallback(variantSelected, null);
          });
        }
      }

        item.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
        stickyATC.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          
          item.find('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
        mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container :radio').change(function() {
          var optionIndex = $(this).closest('.swatch-dropdown__sliding-option-selector-outer-container').attr('data-option-index');
          var optionValue = $(this).val();

          item.find('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });

      if(product.variants.length==1) {
        selectCallback(product.variants[0], null);
      } else {
          // Open on the variant Liquid rendered for, in ONE change: opening on the first available one and correcting it fired two overlapping async handlers that could finish out of order.
          // Scoped to a product FORM and, in a quick view, to the modal: product_tile.liquid renders .swatches-container too, and the tile's copy always holds the DEFAULT variant.
          let swatchScope = isQuickView ? (document.querySelector('.tingle-modal.quick-view') || document) : document;
          let selectedOrFirstAvailableVariantId = parseInt(swatchScope.querySelector(`.main-product__item .swatches-container[data-product-id="${product.id}"]`)?.getAttribute('data-first-available-or-selected-variant-id'));
          let selectedOrFirstAvailableVariant = product.variants.find(variant => variant.id === selectedOrFirstAvailableVariantId);

          if(document.querySelector('body').classList.contains('template-page-bundles') == false){
            productJs.setVariant(selectedOrFirstAvailableVariant || productJs.getFirstAvailableVariant());
          }

          /* Belt and braces for the bundles page, which does not run the line above. */
          let singleOptionSelectors = document.querySelectorAll(`#main-product-item-${product.id} .single-option-selector`);
          let updatedSelectedVariant = false;

          if(selectedOrFirstAvailableVariant){
            singleOptionSelectors.forEach((singleOptionSelector, index) => {
              if(singleOptionSelector.value != selectedOrFirstAvailableVariant.options[index]){

                updatedSelectedVariant = true;
              }
            });
          }

          if(updatedSelectedVariant == true){
            // Set every option before any change fires (same reasoning as productJs.setVariant).
            singleOptionSelectors.forEach((singleOptionSelector, index) => {
              singleOptionSelector.value = selectedOrFirstAvailableVariant.options[index];
            });
            singleOptionSelectors.forEach((singleOptionSelector, index) => {
              singleOptionSelector.value = selectedOrFirstAvailableVariant.options[index];
              singleOptionSelector.dispatchEvent(new Event('change', { bubbles: true }));
            });
          }


      }
    };

    productJs.getFirstAvailableVariant = function() {
      for(var i=0; i < product.variants.length; i++){
        if(product.variants[i].available) {
          return product.variants[i];
        }
      }
      return product.variants[0];
    };
  
    productJs.getVariantBySku = function(sku) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].sku == sku)
          return product.variants[i];
      }    
    };

    productJs.getVariantById = function(id) {
      for(var i=0; i < product.variants.length; i++){ 
        if(product.variants[i].id == id) {
          return product.variants[i];
        }
      }
    };

    productJs.getCurrentVariant = function() {
      var variantId = item.find('[name="id[]"]').val();
        if(variantId!="") {
          return productJs.getVariantById(variantId);
        } else {
          return false;
        }
    };

    window.Branch = window.Branch || {};
    window.Branch.product = window.Branch.product || {};

    // options.force writes even when the badge is claimed: the claim keeps the THEME out, not the owner.
    window.Branch.product.populatePreOrderSwatch = function(preOrderSwatch, desktopText, mobileText, tooltip, options){
      if(!preOrderSwatch || !preOrderSwatch.querySelector('span')){ return; }
      // Every path that fills a badge comes through here, so a claimed one is defended once.
      if(!(options && options.force) && window.Branch.pricing && window.Branch.pricing.isClaimed(preOrderSwatch)){ return; }
      if(preOrderSwatch.getAttribute('data-html-tooltip') === 'true'){
        let desktopSpan = preOrderSwatch.querySelector('.pre-order-swatch__desktop');
        let mobileSpan = preOrderSwatch.querySelector('.pre-order-swatch__mobile');
        if(desktopSpan) desktopSpan.innerHTML = desktopText;
        if(mobileSpan) mobileSpan.innerHTML = mobileText;
      } else {
        preOrderSwatch.querySelector('span').innerHTML = `
          <span class="pre-order-swatch__desktop">
              ${desktopText}
          </span>
          <span class="pre-order-swatch__mobile">
              ${mobileText}
          </span>
          <svg aria-hidden="true" tabindex="-1" role="presentation" class=" icon icon-tooltip" viewBox="0 0 18 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26191 16.8867C14.0714 16.8867 17.9702 13.1436 17.9702 8.52635C17.9702 3.90907 14.0714 0.166016 9.26191 0.166016C4.45243 0.166016 0.553574 3.90907 0.553574 8.52635C0.553574 13.1436 4.45243 16.8867 9.26191 16.8867ZM8.01518 8.62759C7.85935 8.77719 7.78143 8.9664 7.78143 9.19521V10.1984C7.78143 10.4273 7.85935 10.6209 8.01518 10.7793C8.17101 10.9289 8.3681 11.0037 8.60643 11.0037C8.84476 11.0037 9.04185 10.9289 9.19768 10.7793C9.35351 10.6209 9.43143 10.4273 9.43143 10.1984V9.71003C9.43143 9.69243 9.43601 9.67923 9.44518 9.67043L9.50018 9.64403C9.89435 9.58242 10.2564 9.48122 10.5864 9.34042C10.9256 9.19081 11.2189 8.9972 11.4664 8.75959C11.7231 8.51318 11.9202 8.22277 12.0577 7.88836C12.1952 7.54514 12.2639 7.15353 12.2639 6.71351C12.2639 6.12388 12.1127 5.59586 11.8102 5.12944C11.5077 4.66302 11.0998 4.29341 10.5864 4.0206C10.0823 3.73899 9.51393 3.59818 8.88143 3.59818C8.37726 3.59818 7.9006 3.69059 7.45143 3.87539C7.01143 4.0514 6.62643 4.30221 6.29643 4.62782C6.10393 4.81263 6.01685 5.01504 6.03518 5.23505C6.05351 5.45506 6.17268 5.64426 6.39268 5.80267C6.60351 5.95228 6.80976 6.00068 7.01143 5.94788C7.22226 5.88627 7.40101 5.79387 7.54768 5.67067C7.73101 5.52106 7.93268 5.40226 8.15268 5.31425C8.38185 5.22625 8.62476 5.18225 8.88143 5.18225C9.21143 5.18225 9.50476 5.24825 9.76143 5.38025C10.0273 5.51226 10.2335 5.69267 10.3802 5.92148C10.536 6.15029 10.6139 6.4143 10.6139 6.71351C10.6139 7.11832 10.5223 7.44394 10.3389 7.69035C10.1648 7.93676 9.92643 8.11717 9.62393 8.23157C9.32143 8.33717 8.98226 8.38998 8.60643 8.38998C8.3681 8.38998 8.17101 8.46918 8.01518 8.62759ZM7.91893 13.1686C8.0656 13.3006 8.27185 13.3666 8.53768 13.3666H8.71643C8.98226 13.3666 9.18393 13.3006 9.32143 13.1686C9.4681 13.0278 9.54143 12.8298 9.54143 12.5745V12.3501C9.54143 12.0949 9.4681 11.9013 9.32143 11.7693C9.18393 11.6285 8.98226 11.5581 8.71643 11.5581H8.53768C8.27185 11.5581 8.0656 11.6285 7.91893 11.7693C7.78143 11.9013 7.71268 12.0949 7.71268 12.3501V12.5745C7.71268 12.8298 7.78143 13.0278 7.91893 13.1686Z" fill="white"></path>
          </svg>`;
        preOrderSwatch.querySelector('span').setAttribute('data-tooltip', `${tooltip}`);
      }
      preOrderSwatch.setAttribute('data-display', 'true');
    };

    window.Branch.product.getOriginalPrice = function(currentVariant, discount_code_amount){
      var originalPriceAmount = null;
      if(currentVariant.compare_at_price != null){
        if(currentVariant.compare_at_price > currentVariant.price) {
          var originalPriceAmount = currentVariant.compare_at_price;
        } else if (discount_code_amount > 0) {
          var originalPriceAmount = currentVariant.price;
        } 
      } else {
        if (discount_code_amount > 0) {
          var originalPriceAmount = currentVariant.price;
        } 
      }

      return originalPriceAmount;
    }

    window.Branch.product.getCurrentPrice = function(currentVariant, discount_code_amount){
      if (discount_code_amount > 0) {
        var currentPriceAmount =  Math.floor(((100.0 - discount_code_amount) * currentVariant.price) / 100.0);
      } else {
        var currentPriceAmount = currentVariant.price;
      }
      return currentPriceAmount;
    }

      productJs.updateDiscountCodePrice = function(variant, product, variantSwatchValue) {
        let priceData =  document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`) ? JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${variant.id}`] : {};
        
        // console.log('priceData', priceData)

        // console.log('priceData', priceData, variant, product);
        if(priceData['cpx']){
          let originalPrice = 0;
          let currentPrice = 0;
          let discountMessage = "";
          let discountAmount = 0;
          let hidePdpBadgeMessage = false;
          let overridePdpTooltip = false;
          let pdpTooltipHtml = '';
          let activeCampaignPromoStylingEnabled = false;
          let activeCampaignSwatchColorEnabled = false;

 

          if(priceData['constituents']){
            let bundleDiscountAmount = 5;
            let specialBundleProducts = "cable-organizer,open-box-cable-organizer,artisan-drawer,nested-coffee-tables".split(',').filter(Boolean);
            if(specialBundleProducts.includes(product['handle'])){bundleDiscountAmount = 0};
            priceData['constituents'].forEach((constituent) => {
              let codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(constituent.price) * parseInt(constituent.quantity), parseInt(constituent.compare_at_price) * parseInt(constituent.quantity), 0, '', constituent.handle);
              let codeDiscountAmountPercentage = codeDiscountData['discountAmount'] > 0 ? ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + bundleDiscountAmount : 0 + bundleDiscountAmount;

              originalPrice = originalPrice + codeDiscountData.originalPrice;
              currentPrice = currentPrice + ((parseInt(constituent.price)) * ((100 - codeDiscountAmountPercentage)/ 100) * parseInt(constituent.quantity));
            })

            let bundleCampaignHandles = [product.handle].concat(priceData['constituents'].map((c) => c.handle));
            let campaign1Handles = (discountCodeData.active_campaign_1_is_active ? discountCodeData.active_campaign_1_product_handles : '').replaceAll(' ', '').split(',');
            let campaign2Handles = (discountCodeData.active_campaign_2_is_active ? discountCodeData.active_campaign_2_product_handles : '').replaceAll(' ', '').split(',');
            let bundleStylingHandle = bundleCampaignHandles.find((h) => campaign1Handles.includes(h)) || bundleCampaignHandles.find((h) => campaign2Handles.includes(h));
            if(bundleStylingHandle){
              let bundleStyling = window.Branch.functions.returnDiscountCodeUpdates(1, 1, 0, '', bundleStylingHandle);
              overridePdpTooltip = bundleStyling.overridePdpTooltip || false;
              pdpTooltipHtml = bundleStyling.pdpTooltipHtml || '';
              activeCampaignPromoStylingEnabled = bundleStyling.activeCampaignPromoStylingEnabled || false;
              activeCampaignSwatchColorEnabled = bundleStyling.activeCampaignSwatchColorEnabled || false;
            }
          } else {
            originalPrice = priceData.opx == "" ? parseInt(priceData.cpx) : parseInt(priceData.opx);
            currentPrice = parseInt(priceData.cpx);
            let discountCodeResult = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, originalPrice, discountAmount, discountMessage, product.handle);
            currentPrice = discountCodeResult.currentPrice;
            originalPrice = discountCodeResult.originalPrice;
            discountAmount = discountCodeResult.discountAmount;
            discountMessage = discountCodeResult.discountMessage;
            hidePdpBadgeMessage = discountCodeResult.hidePdpBadgeMessage || false;
            overridePdpTooltip = discountCodeResult.overridePdpTooltip || false;
            pdpTooltipHtml = discountCodeResult.pdpTooltipHtml || '';
            activeCampaignPromoStylingEnabled = discountCodeResult.activeCampaignPromoStylingEnabled || false;
            activeCampaignSwatchColorEnabled = discountCodeResult.activeCampaignSwatchColorEnabled || false;
                   console.log('discountCodeResult', discountCodeResult)

         
          }
          // console.log('currentPrice', currentPrice);
          // console.log('originalPrice', originalPrice);
          // console.log('item', item);



          console.log('activeCampaignSwatchColorEnabled', activeCampaignSwatchColorEnabled)

          
            if(document.querySelector('body').classList.contains('templateProduct') && isQuickView == false){
              window.Branch.installmentsBanner.initInstallmentsBanner('pdp', currentPrice, null, product.id, variant.id);
            }

          

          let isBundleBuilder = document.querySelector('body .main-product').getAttribute('data-bundle-builder-pop-up') == 'true' ? true : false;

          if(item && item[0] && item[0].querySelectorAll('.pre-order-swatch:not([data-initialized="true"])').length > 0){
            window.Branch.product.initPreOrderSwatch(discountMessage, discountAmount, item[0].querySelectorAll('.pre-order-swatch'), product.id, "Sale", hidePdpBadgeMessage, overridePdpTooltip, pdpTooltipHtml, product.handle, activeCampaignPromoStylingEnabled, activeCampaignSwatchColorEnabled, isBundleBuilder);
          }

          let shouldBeSkipped = false;
          if(document.querySelector('#side-cart')){
            shouldBeSkipped = document.querySelector('#side-cart').getAttribute('data-stack-discount-code-with-bundle-discount') == 'false' && discountMessage != null
          } 


          window.Branch.functions.saleTagUpdate(variant.id, variantSwatchValue, originalPrice, currentPrice, product, 'product', isBundleBuilder);

          // Progressive hydration guard: the gallery renders only the hero slide's .sale
          // server-side; every other image slide is stubbed and hydrated after LCP paint with an
          // EMPTY .sale node (see scripts_snippets_gallery-hydration.js). The saleTagUpdate above
          // therefore only populated whatever .sale nodes existed at this instant. If hydration is
          // still pending, re-run it once galleryHydrated fires so the newly-created .sale nodes
          // get the same discount message. Args are captured for the variant selected right now.
          if(window.Branch.productGallery && window.Branch.productGallery.hydrationState && window.Branch.productGallery.hydrationState !== 'hydrated'){
            const hydratedVariantId = variant.id;
            const hydratedVariantSwatchValue = variantSwatchValue;
            const hydratedOriginalPrice = originalPrice;
            const hydratedCurrentPrice = currentPrice;
            document.addEventListener('galleryHydrated', function reRunSaleTagAfterHydration(){
              window.Branch.functions.saleTagUpdate(hydratedVariantId, hydratedVariantSwatchValue, hydratedOriginalPrice, hydratedCurrentPrice, product, 'product', isBundleBuilder);
            }, { once: true });
          }

          let isSideCartBundleDiscount = isQuickView == true && document.querySelector('.quick-view .main-product__item') && document.querySelector('.quick-view .main-product__item').getAttribute('data-bundle-discount');
          if(isSideCartBundleDiscount && shouldBeSkipped == false){
            let addOnDiscountAmount = parseInt(document.querySelector('.quick-view .main-product__item').getAttribute('data-bundle-discount'));
            let discountMultiplier = ((100 - parseInt(addOnDiscountAmount))/100);
            originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
            currentPrice = priceData.cpx * discountMultiplier;
          }


          if(isBundleBuilder){
            let product_data = JSON.parse(document.querySelector('#bundle-product-data').innerHTML);
            let bundleDiscountAmount = parseInt(product_data[product.id]['bundle_discount'])
            let discount_multiplier = ((100 - parseInt(bundleDiscountAmount))/100);

             let discountCodeResult = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, originalPrice, undefined, undefined, product.handle);

             if(discountCodeResult.discountAmount > 0){
              discount_multiplier = discount_multiplier - (1 - ((100 - parseInt(discountCodeResult.discountAmount))/100));
             }

            

            originalPrice = priceData.opx == "" ? priceData.cpx : priceData.opx;
            currentPrice = priceData.cpx * discount_multiplier;
        }
        if(originalPrice == currentPrice){
          originalPrice = null;
        }

          let priceContainers = item.find('.price-installments-wrapper .price');
          // console.log('here')
          if(priceContainers.length > 0){
            priceContainers.each(function() {
              // A price another feature owns stays as it is — see isClaimed.
              if(window.Branch.pricing && window.Branch.pricing.isClaimed(this)){ return; }
              let priceContainerParent = $(this).parent();
              let quantityRatio = priceContainerParent.closest('.main-product__item').attr('data-quantity-ratio') ? parseInt(priceContainerParent.closest('.main-product__item').attr('data-quantity-ratio')) : 1;
              let currentPriceRatio = currentPrice * quantityRatio;
              let enableDecimalPointPdpPricing = $(this).attr('data-enable-decimal-point-pdp-pricing') == 'true';

              if(enableDecimalPointPdpPricing){
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').html(Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).replace(' ','').replace('.00', ''));
              } else {
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').html(Shopify.formatMoney(currentPriceRatio, Simplistic.formatMoney).split('.')[0].replace(' ', ''));
              }
              priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"])  [data-price="deal"]').attr('data-exact-price', currentPriceRatio);




              if(originalPrice != null && originalPrice){
                let originalPriceRatio = originalPrice * quantityRatio;
                var retailPrice = Shopify.formatMoney(originalPriceRatio, Simplistic.formatMoney).replace('.00', '').replace(' ','');
                var percentDiscount = Math.round( (((originalPriceRatio - currentPrice) * 100 ) / originalPriceRatio) );
                var moneyDiscount = Shopify.formatMoney((originalPriceRatio - currentPrice), Simplistic.formatMoney).replace('.00', '').replace(' ','');
                            
                if(discountMessage && discountMessage != null){
                  var modifiedMessage = discountMessage.replace('<p>',`<p>Save ${percentDiscount}% `)
                  priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]').html(modifiedMessage);
                }
      
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]').html(retailPrice);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail').attr('data-visible', true);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]').html(percentDiscount+'%');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]').html(moneyDiscount);
      
              } else {
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="retail"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) .retail').attr('data-visible', false);
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-percent"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="off-amount"]').html('');
                priceContainerParent.find('.price:not([data-pdp-bundles="true"]):not([data-addon="true"]) [data-price="discount-code-off-percent"]').html('');
              }
            })
          }
          // PDP accessory option row: add the selected accessory to the deal price and installments.
          if(isQuickView == false && window.Branch.pdpAccessoryOption){
            window.Branch.pdpAccessoryOption.refresh('price', product.id);
          }
        }
      };


    productJs.getProduct = function() {
      return product;
    };

	productJs.getCurrentVariantOption = function(option) {
      var value = '';
      $.each(product.options, function(key, val){
        if(val.toUpperCase()==option.toUpperCase()) {
          value = productJs.getCurrentVariant()[('option'+(key+1))];
        }
      });
      return value;
    };

    productJs.setVariant = function(variant){
      if(variant) {
        if(!isNaN(variant)) {
          variant = productJs.getVariantById(variant);
        }
        // Set every option first, then fire the changes. Firing per option ran onVariantSelected with
        // half-updated combinations (new option 1 + old option 2), and that async run could finish last.
        // Native events reach Shopify's onchange (registered first) before the jQuery handler that rebuilds
        // the next option's list; re-setting each value before its event undoes a rebuild that dropped a
        // sold-out target.
        var selectorValues = [];
        item.find('.single-option-selector').each(function(){
          var selector = this;
          var option = $(selector).data('option');
          $(selector).find('option').each(function(){
            if(this.value == variant[option]){
              selectorValues.push({ selector: selector, value: this.value });
              return false;
            }
          });
        });
        selectorValues.forEach(function(entry){ entry.selector.value = entry.value; });
        selectorValues.forEach(function(entry){
          entry.selector.value = entry.value;
          entry.selector.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    };
  
    var onVariantSelected = function() {
      // Setting a variant fires this once per option, and the handler is async — so each run takes a ticket and a stale one stops rather than repainting the form behind it.
      var latestSelection = 0;

      return async function(variant, selector) {
        var selection = ++latestSelection;
        window.Branch.product.variantChangeActive = true;
        var start = new Date().getTime();
        if(variant && variant.id) {
          let variantSwatchValue = false;

          if(!isQuickView){
            window.Branch.product._currentProduct = product;
            window.Branch.product._currentVariant = variant;
          }

          let productGallery = document.querySelector(`.main-product-gallery[data-product-id="${product.id}"]`);

          // Composite renders (two stacked image layers per slide) for the selected variant only,
          // built on each selection before the gallery is filtered and re-initialized below.
          // Building them for every variant on the first selection put 302 slides into Duo's
          // gallery on page load, most of them never shown.
          if(productGallery){
            productGallery._compositeVariantsBuilt = productGallery._compositeVariantsBuilt || {};
            if(!productGallery._compositeVariantsBuilt[variant.id]){
              productGallery._compositeVariantsBuilt[variant.id] = true;
              productGallery.setAttribute('data-composite-render-images-run', true);
              // Wait for composite render images to complete before continuing
              await window.Branch.compositeRenderImage.initRenderImagesForProduct('main-product', isQuickView, Object.assign({}, product, { variants: [variant] }));

              // The one await, so the one place a later selection can have overtaken this run. variantChangeActive is left to the run that overtook it.
              // Per variant now rather than once per gallery, so this awaits on every colour change and a run is overtaken more often, not less.
              if(selection !== latestSelection) return;
            }
          }

          if(productGallery && productGallery.getAttribute('data-first-user-group-set') !== 'true'){
            productGallery.setAttribute('data-first-user-group-set', true);
              // Set data-first-user-group on gallery items
              const galleryItems = document.querySelectorAll(`.main-product__item[data-quick-view="${isQuickView}"] .main-product-gallery__item`);
              galleryItems.forEach(item => {
                const userGroupsAttr = item.getAttribute('data-user-groups');
                if (userGroupsAttr) {
                  // Remove leading/trailing underscores and split by comma
                  const groups = userGroupsAttr.replace(/^_|_$/g, '').split(',').map(g => g.trim());

                  // Find first non-default group, or use default if it's the only option
                  let firstGroup = null;
                  for (const group of groups) {
                    if (group !== 'default') {
                      firstGroup = group;
                      break;
                    }
                  }

                  // If no non-default group found, use default if it exists
                  if (!firstGroup && groups.includes('default')) {
                    firstGroup = 'default';
                  }

                  if (firstGroup) {
                    item.setAttribute('data-first-user-group', firstGroup);
                  }
                }
              });
          }

          

          if(isQuickView == false && typeof selected_main_product != undefined){
            selected_main_product['selected_variant'] = variant;
          }

          const bundleProduct = product.tags && product.tags.includes("bundle") ? true : false;
          if(bundleProduct){
            if(document.querySelector('body').classList.contains('template-page-bundles')){
              window.Branch.product.updateOldStyleBundle(variant.id, product.id, 'bundle-builder')
            }
            else {
              if(window.Branch.bundleScripts.updateBundleCartData){
                window.Branch.bundleScripts.updateBundleCartData(variant, product.id);
              }
            }
          }

          var discount_code_amount = 0;
          var discount_code_message = '';
          var discount_code_swatch_override = '';
          

          if(document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${product.id}"]`)) {
            let addonsCurrentMainProductSelected = document.querySelector(`.addons-current-main-product-selected[data-product-id="${product.id}"]`);
            if(addonsCurrentMainProductSelected){
              variant.options.forEach((optionValue, index) => {
                addonsCurrentMainProductSelected.setAttribute(`data-option${index + 1}`, optionValue);
              })
              addonsCurrentMainProductSelected.setAttribute(`data-option-names`, product.options.map(optionName => Simplistic.handleize(optionName)).join(','));
            }

            let handlesToHide = [];
            let addonsToHideWhenVariantSelectedData = JSON.parse(document.querySelector(`.addons_to_hide_when_variant_selected[data-product-id="${product.id}"]`).innerText);
            
            addonsToHideWhenVariantSelectedData.forEach((dataLine) => {
              let index = product.options.findIndex(optionName => optionName.toLowerCase() === dataLine.option_name.toLowerCase());
              if(variant[`option${index + 1}`] && variant[`option${index + 1}`] == dataLine.option_value && dataLine.hide_on_pdp == true){
                handlesToHide.push(dataLine.addon_handle.toLowerCase());
              }
            })

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .item[data-hidden="true"]`).forEach((addonElementToShow) => {
              addonElementToShow.style.display = '';
              addonElementToShow.setAttribute('data-hidden', 'false');
            });

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .addon_Count`).forEach((addonCount) => {
              addonCount.innerHTML = `${addonCount.getAttribute('data-orig-length')} items`;
              addonCount.setAttribute('data-modified', 'false');
            })

            handlesToHide.forEach((handleToHide) => {
              let addonElementsToHide = document.querySelectorAll(`.main-product__item  .add-to-cart-form[data-product-id="${product.id}"] .addons__container .item[data-product-handle="${handleToHide}"]`);
              if(addonElementsToHide.length > 0){
                addonElementsToHide.forEach((addonElementToHide) => {
                  addonElementToHide.setAttribute('data-hidden', 'true');
                  addonElementToHide.style.display = 'none';
                  if(addonElementToHide.closest('.swiper').querySelector('.addon_Count')){
                    addonElementToHide.closest('.swiper').querySelector('.addon_Count').setAttribute('data-modified', 'true');
                  }
                })
              }
            })

            document.querySelectorAll(`.main-product__item .add-to-cart-form[data-product-id="${product.id}"] .addons .addon_Count[data-modified="true"]`).forEach((addonCount) => {
              addonCount.innerHTML = `${addonCount.getAttribute('data-orig-length') - handlesToHide.length} items`;
            })

            if(pdpaAddOnSwiperInstances && pdpaAddOnSwiperInstances.length > 0){
              pdpaAddOnSwiperInstances.forEach((pdpaAddOnSwiperInstance) => {
                pdpaAddOnSwiperInstance.update();
              })
            } 
          }

          let shippingSectionDataSection = document.querySelector(`#shipping-info-section-data[data-product-id="${product.id}"]`);
          if(shippingSectionDataSection){
            let shippingSectionData = JSON.parse(shippingSectionDataSection.innerText);
            let optionSelector = `option${shippingSectionData.option_index + 1}`;
            if(variant[`${optionSelector}`]) {
              let optionFromVariant = variant[`${optionSelector}`];
              let imageFromData = shippingSectionData.option_values[`${optionFromVariant}`];
              let shippingInfoImage = document.querySelector('.shipping-info-section__image');
              if(imageFromData && imageFromData != "") {
                shippingInfoImage.setAttribute('srcset', window.Branch.functions.returnSrcSet(imageFromData, 900))
              } else {
                shippingInfoImage.setAttribute('srcset', window.Branch.functions.returnSrcSet(shippingSectionData.backup_image, 900))
              }
            }
          }


          let epigraphInstances = document.querySelectorAll('epigraph-ar');
          if(epigraphInstances.length > 0){
            epigraphInstances.forEach((epigraphInstance) => {
              epigraphInstance.setAttribute('sku', variant.sku)
            })
          }

          if(document.querySelector(`.pre-order-swatch-data[data-product-id="${product.id}"]`)){
            let pdp_swatch_metafield_value = JSON.parse(document.querySelector(`.pre-order-swatch-data[data-product-id="${product.id}"]`).innerText);
            let variant_swatch_value = pdp_swatch_metafield_value['variant_level'][`${variant.id}`];         
            let preOrderSwatches = document.querySelectorAll(`.pre-order-swatch[data-product-id="${product.id}"]:not(.free-gift-preorder-swatch)`);

            let campaignPreOrderMessageOverride = window.Branch.functions.returnSalesTagText(product.handle, 'fromHandle', 'pre-order-swatch');
            let campaignPreOrderTooltipMessageOverride = window.Branch.functions.returnSalesTagText(product.handle, 'fromHandle', 'pre-order-swatch-tooltip');

            if(variant_swatch_value){
              variantSwatchValue = true;
              let variant_swatch_text_value = variant_swatch_value[0];
              let variant_swatch_tooltip_value = variant_swatch_value[1];

              preOrderSwatches.forEach((preOrderSwatch) => {
                let backupDesktop = preOrderSwatch.getAttribute('data-text-fallback') || variant_swatch_text_value;
                let backupMobile = preOrderSwatch.getAttribute('data-text-fallback-mobile') || variant_swatch_text_value;
                window.Branch.product.populatePreOrderSwatch(preOrderSwatch, backupDesktop, backupMobile, variant_swatch_tooltip_value);
              })
            } else if (preOrderSwatches[0] && preOrderSwatches[0].getAttribute('data-text-fallback') != "") {
              preOrderSwatches.forEach((preOrderSwatch) => {
                let textFallBackDesktop = preOrderSwatch.getAttribute('data-text-fallback');
                let textFallBackMobile = preOrderSwatch.getAttribute('data-text-fallback-mobile');
                let tooltipFallback = preOrderSwatch.getAttribute('data-tooltip-fallback');
                if (campaignPreOrderTooltipMessageOverride != null && campaignPreOrderTooltipMessageOverride !== '') {
                  tooltipFallback = campaignPreOrderTooltipMessageOverride;
                }

                window.Branch.product.populatePreOrderSwatch(preOrderSwatch, textFallBackDesktop, textFallBackMobile, tooltipFallback);
              })
            }
          }

          if(window.Branch && window.Branch.product && window.Branch.product.updateFeaturesSection){
            window.Branch.product.updateFeaturesSection(variant);
          }

          if(window.Branch && window.Branch.pdp && window.Branch.pdp.calloutChangeOnVariantSelect) {
            window.Branch.pdp.calloutChangeOnVariantSelect(variant.id, product.id);
          }

          

          let bundleTagPresent = product.tags && product.tags.includes('bundle')
          if(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`)){
            let ship_date_metafield_value = JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${product.id}`).innerText)[`${variant.id}`];


            let ship_date_show_available = false;
            if(document.querySelector(`#variant_ship_date_show_available--${product.id}`)){
              ship_date_show_available = JSON.parse(document.querySelector(`#variant_ship_date_show_available--${product.id}`).innerText)[`${variant.id}`] == 'true';
            }
            let msbdMessage = document.querySelector(`#main-product-item-${product.id} .msbd-message[data-product-id="${product.id}"]`);
            let whiteGlove = ship_date_metafield_value.toLowerCase().includes('white glove');

            /* Start of PDP simplication test code - delete when test is over */
            let originalString = ship_date_metafield_value;
            /* End of PDP simplication test code - delete when test is over */

            if(whiteGlove){
              ship_date_metafield_value = ship_date_metafield_value.replace(/White Glove Delivery - Delivery and installation/ig, 'Installation').trim();
            }
           
            let oosMessage = ship_date_metafield_value;
            let msbdInput = msbdMessage.querySelector(`#msbd-message__input--${product.id}`);

            if(!variant.available && !bundleTagPresent){
              msbdMessage.setAttribute('data-available', 'false');
                msbdMessage.querySelector(`.msbd-message__text--oos`).setAttribute('aria-hidden', 'false');
                msbdMessage.querySelector(`.msbd-message__text--available`).setAttribute('aria-hidden', 'true');  
              
              msbdInput.setAttribute('value', oosMessage);
              msbdInput.closest('.msbd-message').querySelector('.msbd-message__text--oos .msbd-message__oos-span').innerHTML = `${oosMessage} |`;
            } else {
              msbdMessage.setAttribute('data-available', 'true');
                msbdMessage.querySelector(`.msbd-message__text--oos`).setAttribute('aria-hidden', 'true');
                msbdMessage.querySelector(`.msbd-message__text--available`).setAttribute('aria-hidden', 'false');
                msbdInput.closest('.msbd-message').querySelector('.msbd-message__text--oos .msbd-message__oos-span').innerHTML = `${oosMessage} |`;

              msbdInput.setAttribute('value', ship_date_metafield_value)
            }
    
            

            msbdInput.setAttribute('data-variant-id', variant.id);

            let spanHTML = `<span class="msbd-available-span" aria-hidden="true">${whiteGlove ? 'White Glove' : 'Available'} | </span>`;
            let stringHTML = `<span class="msbd-string-span">${ship_date_metafield_value}</span>`;

            msbdMessage.querySelector(`.msbd-message__text--available span.msbd-message__ship-date-span`).innerHTML = `${ship_date_show_available ? spanHTML : ''} ${stringHTML}`;
          }
    
          

          let priceDataElement = document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`);

          

            //Swatches code
            var form = item.find('form');

            
            for(var i=0,length=variant.options.length; i<length; i++) {
              var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              var radioButtonSticky = stickyATC.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              var radioButtonMobileSticky = mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
              if(radioButton.length > 0) {
                radioButton.get(0).checked = true;

                if(radioButtonMobileSticky && radioButtonMobileSticky.get(0)){
                  radioButtonMobileSticky.get(0).checked = true;
                  let dropdowns = document.querySelectorAll('.sticky-atc__options .swatch-dropdown');
                  if(dropdowns.length > 0){
                    let dropdown = dropdowns[radioButtonMobileSticky[0].getAttribute('name').replace("option-mobile-sticky-", "")];
                    if(dropdown){
                      let label = dropdown.querySelector('label');
                      let value = radioButtonMobileSticky[0].getAttribute('value');
                      label.setAttribute('data-option-value', `${value.replace(" ", "-").toLowerCase()}`);
                      if(label.getAttribute('data-type') == "color"){
                        label.classList = `swatch-dropdown__bar-label swatch-dropdown__bar-label--selected  color-${value.replaceAll(" ", "-").replaceAll("/", "-").toLowerCase()}`;
                        label.closest('.swatch-dropdown__bar-element-inner-container').querySelector('.swatch-dropdown__open-close-button-container-label').innerHTML = `${value}`;
                      } else {
                        let xsLabel = value.replaceAll(" inches", "″").replaceAll(" Inches", "″");
                        let xsLabelArray = value.replaceAll(" inches", " inches #").replaceAll(" Inches", " Inches #").split('#');
                        if(xsLabelArray.length > 1){
                          xsLabelArray.splice(1, 1)
                          xsLabel = xsLabelArray.join().replaceAll(" inches", "″").replaceAll(" Inches", "″").replaceAll(",", "").split('+')[0];
                        }
                        value = value.replace(/ ?inches/gi, "″");
                        
                        label.querySelector('span.swatch-dropdown__bar-label-option-value:not(.swatch-dropdown__bar-label-option-value--xs)').innerHTML = `${window.Branch.functions.stripVariantText(value, variantTextReplacementMetafield)}`;
                        label.querySelector('span.swatch-dropdown__bar-label-option-value--xs').innerHTML = `${window.Branch.functions.stripVariantText(xsLabel, variantTextReplacementMetafield)}`;
                        label.querySelector('span.visually-hidden').innerHTML = `${value} ${label.getAttribute('data-option-key')}`;

                      }
                    }
                  }
                }
                if(radioButtonSticky && radioButtonSticky.get(0)){
                  radioButtonSticky.get(0).checked = true;
                }
              }
            }

          // console.log('priceDataElement', priceDataElement)
          if(priceDataElement){
            productJs.updateDiscountCodePrice(variant, product, variantSwatchValue);
          }

          let outerGalleryContainer = document.querySelector('.main-product__item[data-quick-view="false"] .main-product-gallery__outer-container');
          let quickViewOuterGalleryContainer = document.querySelector('.main-product__item[data-quick-view="true"] .main-product-gallery__outer-container');

          if(!isQuickView){

            let mainProductGallery = document.querySelector('.main-product__item[data-quick-view="false"] .main-product-gallery');
            if(mainProductGallery){
              let browserName = 'unknown';
              const ua = navigator.userAgent;
              if (ua.indexOf('Firefox') > -1) {
                browserName = 'Firefox';
              } else if (ua.indexOf('SamsungBrowser') > -1) {
                browserName = 'Samsung';
              } else if (ua.indexOf('Edg') > -1) {
                browserName = 'Edge';
              } else if (ua.indexOf('Chrome') > -1) {
                browserName = 'Chrome';
              } else if (ua.indexOf('Safari') > -1) {
                browserName = 'Safari';
              }
              mainProductGallery.setAttribute('data-browser', browserName);
            }

            window.Branch.productGallery.prevSelectedUserGroup = window.Branch.productGallery.selectedUserGroup == 'default' ? null : window.Branch.productGallery.selectedUserGroup;
            window.Branch.productGallery.selectedUserGroup = 'default';

            let numberOfVisibleThumbnailItems = document.querySelectorAll('.main-product__item[data-quick-view="false"] .horizontal-thumbnails-carousel-container .main-product-gallery__item.slideVisible').length / 2;
            let loadingOverlay = document.querySelector('.main-product__item[data-quick-view="false"] .main-product-gallery__thumbnails-loading-overlay');
            if(loadingOverlay){
              loadingOverlay.setAttribute('data-number-of-visible-items', numberOfVisibleThumbnailItems);
            }

           
            outerGalleryContainer.setAttribute('data-horizontal-thumbnails-initialized', false);
            
            
            // Get the currently active slide
            let activeSlide = document.querySelector('.main-product__item[data-quick-view="false"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible[data-actual-current-slide="true"]');

            // Store the index within the current user group
            let activeSlides;
            let allSlidesConnectedToVariant = document.querySelectorAll('.main-product__item[data-quick-view="false"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible');
            if(window.Branch.productGallery.prevSelectedUserGroup == 'default'){
              activeSlides = allSlidesConnectedToVariant;
            } else {
              // Get slides that belong to the current user group (not hidden)
              activeSlides = document.querySelectorAll('.main-product__item[data-quick-view="false"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible[data-hidden-via-user-groups="false"]');
              if(activeSlides.length === 0) {
                // Fallback to slides that match the user group
                activeSlides = document.querySelectorAll('.main-product__item[data-quick-view="false"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide[data-user-groups*="' + window.Branch.productGallery.prevSelectedUserGroup + '"]');
              }
            }

            // Sort activeSlides by data-index attribute
            activeSlides = Array.from(activeSlides).sort((a, b) => {
              const aIndex = parseInt(a.getAttribute('data-index')) || 0;
              const bIndex = parseInt(b.getAttribute('data-index')) || 0;
              return aIndex - bIndex;
            });

            // Find the index of the current slide within the user group slides
            let currentSlideIndexInUserGroup = Array.from(activeSlides).indexOf(activeSlide);
            window.Branch.productGallery.prevSelectedItemIndex = window.Branch.productGallery.selectedItemIndex;
            window.Branch.productGallery.selectedItemIndex = currentSlideIndexInUserGroup;
            // Store this for later use when clicking user group
            window.Branch.productGallery.indexWithinUserGroup = currentSlideIndexInUserGroup;

            // Check if selectedUserGroup is not 'default' or 'overview'
            if (window.Branch.productGallery.prevSelectedUserGroup !== null &&
                window.Branch.productGallery.prevSelectedUserGroup !== 'default' &&
                window.Branch.productGallery.prevSelectedUserGroup !== 'overview') {

              // Find the first element within activeSlides that doesn't have data-dimensions-overlay-view="_none_"
              const firstNonOverlayIndex = Array.from(allSlidesConnectedToVariant).findIndex(slide => {
                const overlayView = slide.getAttribute('data-dimensions-overlay-view');
                return overlayView !== '_none_';
              });

              // If we found such an element, update the indexWithinUserGroup
              if (firstNonOverlayIndex !== -1) {
                window.Branch.productGallery.prevSelectedUserGroup = 'overview';
                window.Branch.productGallery.indexWithinUserGroup = firstNonOverlayIndex;
                window.Branch.productGallery.selectedItemIndex = firstNonOverlayIndex;
              }
            }

          } else {
            if(quickViewOuterGalleryContainer){
                quickViewOuterGalleryContainer.setAttribute('data-horizontal-thumbnails-initialized', false);
            }
          }

          //Filter The images by variant
          filterImages(variant, true, variantSwatchValue);
          window.Branch.productGallery.sortVisibleGalleryItemsByUserGroup(isQuickView);

          if(!isQuickView){
            window.Branch.productGallery.reorderNonActiveSlides();
            window.Branch.productGallery.updateForUserGroups();
            window.Branch.productGallery.initializeMainProductGallery();
            if(window.Branch.pdpAccessoryOption){ window.Branch.pdpAccessoryOption.alignGallery(); }
            let timeoutAmount = 51;

            setTimeout(() => {

                if(window.Branch.productGallery.prevSelectedUserGroup !== 'default') {
                // Find and click the equivalent user group button after variant change
                const prevGroupButton = document.querySelector(`.main-product__item[data-quick-view="false"] .main-product-gallery__user-groups-filter-button[data-link="${window.Branch.productGallery.prevSelectedUserGroup}"]`);
                let buttonToClick = prevGroupButton;

                // If the previous user group doesn't exist, find a fallback button
                if (!buttonToClick) {
                  const allButtons = document.querySelectorAll(`.main-product__item[data-quick-view="false"] .main-product-gallery__user-groups-filter-button`);

                  if (allButtons.length > 0) {
                    // Try to click the 2nd button (index 1) if it exists
                    if (allButtons.length > 1) {
                      buttonToClick = allButtons[1];
                    } else {
                      // Otherwise fall back to the first button
                      buttonToClick = allButtons[0];
                    }
                  }
                }

                if (buttonToClick) {
                  // Don't trigger first thumbnail if we have a stored position
                  const shouldRestorePosition = window.Branch.productGallery.indexWithinUserGroup > 0;

                  if (shouldRestorePosition) {
                    // Prevent automatic first thumbnail click
                    window.Branch.productGallery.userGroupClickShouldTriggerFirstThumbnail = false;
                    window.Branch.productGallery.thumbnailClickShouldTriggerUserGroupClick = false;
                  } else {
                    // Reset flags for normal behavior
                    window.Branch.productGallery.userGroupClickShouldTriggerFirstThumbnail = true;
                    window.Branch.productGallery.thumbnailClickShouldTriggerUserGroupClick = true;
                  }

                  // Small delay to ensure gallery is fully initialized
                  setTimeout(() => {
                    buttonToClick.click();
                    timeoutAmount = 51;
                    let variantsViewedForReference = structuredClone(window.Branch.productGallery.variantsViewed);
                    if(window.Branch.productGallery.variantsViewed && !window.Branch.productGallery.variantsViewed.includes(variant.id)){
                      window.Branch.productGallery.variantsViewed.push(variant.id);
                      timeoutAmount = 500;
                    }
                    
                    if(window.Branch.productGallery.prevSelectedUserGroup == 'default' || window.Branch.productGallery.prevSelectedUserGroup == 'overview'){
                      if(!shouldRestorePosition){
                        timeoutAmount = 51;
                      }
                    }
                    // If we need to restore position, do it after the user group is applied
                    if (shouldRestorePosition) {


                      // Find all visible thumbnails after user group filtering
                      const allThumbnails = document.querySelectorAll(
                        `.main-product__item[data-quick-view="false"] .main-product-gallery__thumbnail.slideVisible`
                      );

                      // Filter to only those that belong to the selected user group
                      const selectedGroup = buttonToClick.getAttribute('data-link');
                      const userGroupThumbnails = Array.from(allThumbnails).filter(thumbnail => {
                        const itemInner = thumbnail.querySelector('.main-product-gallery__thumbnail-item');
                        if (itemInner) {
                          const userGroupsAttr = itemInner.getAttribute('data-user-groups');
                          if (userGroupsAttr) {
                            const groups = userGroupsAttr.replace(/^_|_$/g, '').split(',').map(g => g.trim());
                            return groups.includes(selectedGroup);
                          }
                        }
                        return false;
                      });
                      if (userGroupThumbnails[window.Branch.productGallery.indexWithinUserGroup]) {
                        if(userGroupThumbnails[window.Branch.productGallery.indexWithinUserGroup].getAttribute('data-index') !== '0'){
                          timeoutAmount = 500;
                          console.log('variantsViewedForReference', variantsViewedForReference);
                          if(variantsViewedForReference && variantsViewedForReference.includes(variant.id)){
                            timeoutAmount = 151;
                          }
                        }
                      } 


                      setTimeout(() => {
                        // Click the thumbnail at the stored position if it exists
                        if (userGroupThumbnails[window.Branch.productGallery.indexWithinUserGroup]) {
                          window.Branch.productGallery.thumbnailClickShouldTriggerUserGroupClick = false;
                          window.Branch.productGallery._programmaticSlide = true;
                          userGroupThumbnails[window.Branch.productGallery.indexWithinUserGroup].click();
                        }

                        // Reset the stored index
                        window.Branch.productGallery.indexWithinUserGroup = 0;
                      }, 100);
                    }
                  }, 50);
                }
              } else if(window.Branch.productGallery.selectedItemIndex !== 0) {
                // Slide to the previously selected item index

                console.log('window.Branch.productGallery.swapReversed', window.Branch.productGallery.swapReversed)

                if(window.Branch.productGallery.mainProductGallerySwiper && window.Branch.productGallery.swapReversed == false) {
                  window.Branch.productGallery._programmaticSlide = true;
                  window.Branch.productGallery.mainProductGallerySwiper.slideTo(window.Branch.productGallery.selectedItemIndex, 0);
                }
              }

            if(window.Branch.productGallery.featuredImageDataIndex > -1 && window.Branch.productGallery.selectedItemThumbnailIndex > -1){ 
                  let featuredImageSlide = document.querySelector(`.main-product__item[data-quick-view="false"] .main-product-gallery .main-product-gallery__outer-container .main-product-gallery__item.slideVisible[data-index="${window.Branch.productGallery.featuredImageDataIndex}"]`)
                  // console.log('featuredImageSlide', featuredImageSlide)
                  // console.log('window.Branch.productGallery.selectedItemThumbnailIndex', window.Branch.productGallery.selectedItemThumbnailIndex)
                  if(featuredImageSlide){
                    let thumbnailInners = document.querySelectorAll(`.main-product__item[data-quick-view="false"] .main-product-gallery .horizontal-thumbnails-swiper .main-product-gallery__item.main-product-gallery__thumbnail-item`);
                    if(thumbnailInners.length > 0){
                      let thumbnailInner = thumbnailInners[window.Branch.productGallery.selectedItemThumbnailIndex];
                       if(thumbnailInner){
                        let thumbnail = thumbnailInner.closest('.swiper-slide');
                        window.Branch.productGallery._programmaticSlide = true;
                        thumbnail.click();
                        timeoutAmount = 151;
                        if(window.Branch.productGallery.variantsViewed && !window.Branch.productGallery.variantsViewed.includes(variant.id)){
                          window.Branch.productGallery.variantsViewed.push(variant.id);
                          timeoutAmount = 500;
                        }
                      }
                    }
                  }
                } 



            setTimeout(() => {
              console.log('timeoutAmount', timeoutAmount)
              setTimeout(() => {
                outerGalleryContainer.setAttribute('data-horizontal-thumbnails-display-stand-in', false);
                outerGalleryContainer.setAttribute('data-horizontal-thumbnails-initialized', true);
                // Last word after the restore cascade above: keep the "with accessory" shot in view.
                if(!isQuickView && window.Branch.pdpAccessoryOption){ window.Branch.pdpAccessoryOption.alignGallery(); }
                if(!isQuickView) {
                  setTimeout(() => {

                    console.log('window.Branch.productGallery.selectedItemThumbnailIndex', window.Branch.productGallery.selectedItemThumbnailIndex)
                    if(window.Branch.productGallery.selectedItemThumbnailIndex < 1 || window.Branch.productGallery._firstFeaturedVariantDisplayingOnStandInInitialized == false){
                      window.Branch.productGallery.setMainImageLoadingBackground(isQuickView, true, 0);
                    }
                  }, 1)
                }
              }, timeoutAmount - 50)
            }, 50)
            }, 250)


          } else {
            // Store current quick view slide index and product ID before reinitializing
            let currentQuickViewIndex = 0;
            let shouldPreserveIndex = false;

            // Get the current product ID from the quick view element
            const quickViewElement = document.querySelector('.main-product__item[data-quick-view="true"]');
            const currentProductId = quickViewElement ? quickViewElement.id : null;

            if (window.Branch.productGallery.quickViewGallerySwiper) {
              // Check if we have a stored product ID and if it matches the current one
              if (window.Branch.productGallery.quickViewProductId &&
                  window.Branch.productGallery.quickViewProductId === currentProductId) {
                // Same product, preserve the index
                currentQuickViewIndex = window.Branch.productGallery.quickViewGallerySwiper.activeIndex;
                shouldPreserveIndex = true;
              } else {
                // Different product or first time, reset to first image
                shouldPreserveIndex = false;
              }
            }

            // Store the current product ID for next comparison
            window.Branch.productGallery.quickViewProductId = currentProductId;

            // Reinitialize the quick view gallery
            window.Branch.productGallery.initializeQuickViewProductGallery();

            // Restore the slide position after initialization only if same product
            if (window.Branch.productGallery.quickViewGallerySwiper && shouldPreserveIndex && currentQuickViewIndex > 0) {
              // Check if the index is valid for the new variant
              const totalSlides = window.Branch.productGallery.quickViewGallerySwiper.slides.length;
              const visibleSlides = document.querySelectorAll('.main-product__item[data-quick-view="true"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible').length;
              const maxIndex = visibleSlides - 1;

              if (currentQuickViewIndex <= maxIndex) {
                // Slide to the same index if it exists
                setTimeout(() => {
                  window.Branch.productGallery.quickViewGallerySwiper.slideTo(currentQuickViewIndex);
                }, 50);
              } else if (maxIndex >= 0) {
                // If the index doesn't exist, go to the last available slide
                setTimeout(() => {
                  window.Branch.productGallery.quickViewGallerySwiper.slideTo(maxIndex);
                }, 50);
              }
            }
            setTimeout(() => {
              if(quickViewOuterGalleryContainer){
                quickViewOuterGalleryContainer.setAttribute('data-horizontal-thumbnails-initialized', true);
              }
            }, 500)
          }


          //Update the variant value to add to cart
          item.find('#product-'+product.id+'-variant').val(variant.id);
          let cartText = 'SELECT ADD ON';
          if(item.parents('.main-product[data-quick-view="true"]-bundle').length && document.querySelector(`.pdp-bundles-callout #bundle-addon-${product.id}`))
          {
            cartText = 'SELECT BUNDLE';
          }
          item.siblings('.addon-add-btn').find('.content-available [data-addon-select]').html(`${cartText} +${Shopify.formatMoney(variant.price, Simplistic.formatMoney).replace('.00', '').replace(' ','')}`);
          if(!item.closest(".cart-addons")){     
            item.siblings('.addon-add-btn').find('.content-available [data-addon-select]').attr('onclick', `window.Branch.addons.quickViewHandleATC(${variant.id}, ${item.siblings('.addon-add-btn').find('.content-available [data-addon-select]').attr('data-product-id')})`);
          }
          item.siblings('.addon-add-btn').find('.content-available [data-addon-select]').attr('data-bundle-variant-id', variant.id);

        } else {
          item.find('#product-'+product.id+'-variant').val("");
        }

        if(variant){
          updateButtons(variant);

          const pdpPrices = document.querySelectorAll('.price-installments-wrapper__pdp > div > div');
          if (pdpPrices.length > 0){
            pdpPrices.forEach((pdpPrice) => {
              pdpPrice.setAttribute('data-product-id', product.id)
            })
          }


          let mainProductSwatches = document.querySelectorAll('.main-product .swatch');
          if(mainProductSwatches.length > 0){
            window.Branch.product.updateVariantSwatchTitles(mainProductSwatches, variant, product.id, variantTextReplacementMetafield);
            window.Branch.product.updateColorSwatchTabsSelectedIndicator(mainProductSwatches, variant, product.id);
          }

          $(item).trigger("variantChange", [variant]);

          var end = new Date().getTime();
          var time = end - start;

          if(variantAlreadySelected == false){
            variantAlreadySelected = true;
          }

          /* Update addon thumbnails */
          window.Branch.product.updateAddonThumbnailsToMatchSelectedVariant(product, variant);

          /* Update already-selected addons */
          window.Branch.product.updateSelectedAddons(product, variant)

          if(isQuickView == true){
            let parent = document.querySelector(`.main-product__item .swatches-container[data-product-id="${product.id}"]`)
            if(parent && parent.getAttribute('data-click-allowed') != 'true') {
              // Guarded: it is defined inside setUpSwatchTabsEventListener, and throwing here left variantChangeActive true so every later change was ignored.
              if(typeof window.Branch.product.removeOverlayFromSwatches === 'function'){
                window.Branch.product.removeOverlayFromSwatches(product.id, '.main-product__item[data-quick-view="true"]')
              }
            }
          }
        }

      window.Branch.product.variantChangeActive = false;
      }

    };

    var filterImages = function(variant, notSwitchImg, variantSwatchValue) {
      if(variant) {

       // First, find which slideVisible item has the attribute BEFORE removing it
          const itemWithAttrBefore = document.querySelector(
            `#main-product-item-${product.id} .main-product-gallery__item.slideVisible[data-first-image-atf]`
          );

          window.Branch.productGallery.sortGalleryItemsByIndex(isQuickView, false);

          // Get all slideVisible items
          const allVisibleItems = document.querySelectorAll(
            `#main-product-item-${product.id} .main-product-gallery__item.slideVisible`
          );

          // Find the index of the item that had the attribute
          let previousIndex = -1;
          if (itemWithAttrBefore) {
            previousIndex = Array.from(allVisibleItems).indexOf(itemWithAttrBefore);
          }

          productJs.filterThumbs(product.options, variant, item.find(`.main-product-gallery__inner-container`), product['allow_image_filtering_by_size']);

          const allGalleryImages = document.querySelectorAll(
            `#main-product-item-${product.id} .main-product-gallery__item`
          );

          allGalleryImages.forEach(img => {
            img.removeAttribute('data-hidden-via-user-groups');
          });

          let allVisibleItemsAfterFiltering = document.querySelectorAll(
            `#main-product-item-${product.id} .main-product-gallery__item.slideVisible`
          );

          // Add to the first slideVisible item
          let firstVisibleItem = document.querySelector(
            `#main-product-item-${product.id} .main-product-gallery__item.slideVisible`
          ); 

          if(previousIndex !== -1) {
            const visibleItemsAfter = document.querySelectorAll(
              `#main-product-item-${product.id} .main-product-gallery__item.slideVisible`
            );
            if(visibleItemsAfter[previousIndex]) {
              firstVisibleItem = visibleItemsAfter[previousIndex];
            }
          }
      }
    };
    
    var updateButtons = function(variant) {
      var status;
      if(product.available) {
        status = variant ? variant.status : 'available';
      } else {
        status = 'soldout';
      }

      let variantOptionSelector = product && variant ? document.querySelector(`.options[data-quick-view="true"] .select-variant#product-select-${product.id} option[value="${variant.id}"]`) : undefined;
      
      if(variantOptionSelector && variantOptionSelector.getAttribute('data-variant-avaiable') == "false"){
        status = 'soldout';
      }
      item.find('.buttons-wrapper .add-button, .buttons-wrapper .sold-out-button, .soldout-product-message').hide(); //Grid
      item.find('.content-available, .content-soldout').hide(); //Product page
      stickyATC.find('.content-available, .content-soldout').hide(); //Sticky
      mobileStickyAtc.find('.content-available, .content-soldout').hide(); //Mobile Sticky
      item.find('.quantity-box').removeClass('disabled'); //Product page
      if ($('.chat-with-sales-button-pdp').length) {
        switch(status) {
          case "available":
            item.find('.content-available').show(); //Product page
            item.find('.main-product__atc-container').attr('data-atc-visible', true);
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').hide(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').show(); //Grid
            stickyATC.find('.content-available').show(); //Sticky
            mobileStickyAtc.find('.content-available').css("display", "flex") //Mobile Sticky
            item.find('.quantity-box').show(); //Product page
            break;
          case "soldout":
            item.find('.main-product__atc-container').attr('data-atc-visible', false);
            item.find('.buttons-wrapper .add-button').prop("disabled",true);
            item.find('.soldout-product-message').show(); //Grid
            item.find('.quantity-box').hide(); //Product page
            if(item.attr('data-quick-view') == 'true'){
              item.find('.content-soldout').show(); //Product page
            }
            else if (item.parents('body.template-product-chat-with-sales').length == false) {
              item.find('.content-soldout').show(); //Product page
            }
            
            
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').show(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').hide(); //Grid
            stickyATC.find('.content-soldout').show(); //Sticky
            mobileStickyAtc.find('.content-soldout').css("display", "flex") //Mobile Sticky
            break;
        }
      }
      else {
        switch(status) {
          case "available":
            item.find('.buttons-wrapper .add-button').show(); //Grid
            item.find('.main-product__atc-container').attr('data-atc-visible', true);
            item.find('.content-available').show(); //Product page
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').hide(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').show(); //Grid
            stickyATC.find('.content-available').show(); //Sticky
            mobileStickyAtc.find('.content-available').css("display", "flex"); //Mobile Sticky
            item.find('.quantity-box').removeClass('disabled'); //Product page
            break;
          case "soldout":
            item.find('.buttons-wrapper .sold-out-button').show(); //Grid
            item.find('.soldout-product-message').show(); //Grid
            item.find('.main-product__atc-container').attr('data-atc-visible', false);
            item.find('.quantity-box').addClass('disabled'); //Product page
            item.find('.content-soldout').show(); //Product page
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-soldout').show(); //Grid
            item.closest('.main-product[data-quick-view="true"]').find('.addon-add-btn .content-available').hide(); //Grid
            stickyATC.find('.content-soldout').show() //Sticky
            mobileStickyAtc.find('.content-soldout').css("display", "flex"); //Mobile Sticky
            break;
        }
      }
    };


  function showTooltip($trigger, options = {}) {
      const settings = $.extend({
          containerSelector: '.swatches-container',
          tooltipSelector: '.tooltip',
          modeAttr: 'tabs',
          displayClass: 'mobile-display',
          duration: 2000
      }, options);

      const $container = $trigger.closest(settings.containerSelector);
      const $tooltip = $trigger.find(settings.tooltipSelector);

      const rect = $tooltip[0].getBoundingClientRect();
      const $floatingTooltip = $tooltip.clone()
          .addClass(settings.displayClass)
          .addClass('tooltip--temp');

      $floatingTooltip.css({
          position: 'fixed',
          top: rect.top + 'px',
          left: rect.left + 'px',
          width: rect.width + 'px',
          opacity: 1,
          visibility: 'visible',
          bottom: 'auto',
          'pointer-events': 'none',
          'z-index': 9999,
          'transform': 'translateY(calc(-100% + 5px))'
      });

      $('#page').append($floatingTooltip);

      const $outer = $tooltip.closest('.swatch-tab-inner');

      const scrollTop = $outer.scrollTop();  // save
      const scrollLeft = $outer.scrollLeft();

      $outer.css({
          'overflow': 'hidden',
          'scroll-behavior': 'auto'
      });

      const cleanup = () => {
          $floatingTooltip.remove();
          $outer.css('overflow', ''); 
          $outer.scrollTop(scrollTop); 
          $outer.scrollLeft(scrollLeft);
          $trigger.off('mouseleave.tooltipTemp');
      };

      const removeTimeout = setTimeout(cleanup, settings.duration);

      $trigger.on('mouseleave.tooltipTemp', () => {
          clearTimeout(removeTimeout);
          cleanup();
      });
    }
   

    var updateOptionsInSelector = function(selectorIndex) {
      switch (selectorIndex) {
          case 0:
              var key = "root";
              var selector = item.find(".single-option-selector:eq(0)");
              break;
          case 1:
              var key = item.find(".single-option-selector:eq(0)").val();
              var selector = item.find(".single-option-selector:eq(1)");
              break;
          case 2:
              var key = item.find(".single-option-selector:eq(0)").val();
              key += " / " + item.find(".single-option-selector:eq(1)").val();
              var selector = item.find(".single-option-selector:eq(2)")
      }
      var initialValue = selector.val();
      selector.empty();
      var options = optionsMapAll[key];
      if (options) {
          for (var i = 0; i < options.length; i++) {
              var option = options[i];
              var newOption = jQuery("<option></option>").val(option).html(option);
              selector.append(newOption)
          }
      }


      var availableOptions = optionsMap[key];
      var existingOptions = optionsMapAll[key];

      item.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
          if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
            $(this).off();
              if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                  $(this).removeClass("soldout").find(":radio").removeAttr("checked");
                  $(this).find('.tooltip').text(`${$(this).attr("data-value")}`);
              } else {
                  if (item.parents('.template-product-chat-with-sales').length == false) {
                    $(this).addClass("soldout").find(":radio").removeAttr("checked");
                    $(this).find('.tooltip').text('Out of stock');

                    if(window.Branch.functions.isTouchDevice()){
                    $(this).on('click', function(){
                      showTooltip($(this));
                    })
                  } else {
                    $(this).on('mouseenter', function(){
                      showTooltip($(this));
                    })
                  }
                   }
                
              }
              $(this).find('input').prop('disabled', false);
              $(this).removeClass("option-not-available");
          } else {
              $(this).find('input').prop('disabled', true)
              $(this).find('.tooltip').text('Not available')
              $(this).addClass("option-not-available");
              if(window.Branch.functions.isTouchDevice()){
                $(this).on('click', function(){
                  showTooltip($(this));
                });
              } else {
                $(this).on('mouseenter', function(){
                  showTooltip($(this));
                })
              }
          }
      });

      if(isQuickView == false){
        stickyATC.find('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
          if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
            $(this).off();
              if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                  $(this).removeClass("soldout").find(":radio").removeAttr("checked");
                  $(this).find('.tooltip').text(`${$(this).attr("data-value")}`);
              } else {
                  if (item.parents('.template-product-chat-with-sales').length == false) {
                    $(this).addClass("soldout").find(":radio").removeAttr("checked");
                    $(this).find('.tooltip').text('Out of stock');
                    if(window.Branch.functions.isTouchDevice()){
                      $(this).on('click', function(){
                        showTooltip($(this));
                      })
                    } else {
                      $(this).on('mouseenter', function(){
                        showTooltip($(this));
                      })
                    }
                    }


              }
              $(this).find('input').prop('disabled', false);
              $(this).removeClass("option-not-available");
          } else {
              $(this).find('input').prop('disabled', true)
              $(this).find('.tooltip').text('Not available')
              $(this).addClass("option-not-available");
              if(window.Branch.functions.isTouchDevice()){
                $(this).on('click', function(){
                  showTooltip($(this));
                });
              } else {
                $(this).on('mouseenter', function(){
                  showTooltip($(this));
                })
              }
          }
        });
      }

      /* new sticky atc */

      if(isQuickView == false){
        mobileStickyAtc.find('.swatch-dropdown__sliding-option-selector-outer-container[data-option-index="' + selectorIndex + '"] .swatch-dropdown__sliding-option-selector-element').each(function() {
          let label = document.querySelectorAll('.swatch-dropdown')[selectorIndex].querySelector('.swatch-dropdown__bar-label');
          if (jQuery.inArray($(this).attr("data-value"), existingOptions) !== -1) {
            $(this).off();
              if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                  $(this).removeClass("soldout").find(":radio").removeAttr("checked");
                
                  label.setAttribute('data-availability', 'available');
              } else {
                if (item.parents('.template-product-chat-with-sales').length == false) {
                  $(this).addClass("soldout").find(":radio").removeAttr("checked");  
                  label.setAttribute('data-availability', 'soldout');
                }
              }
              $(this).find('input').prop('disabled', false);
              $(this).removeClass("option-not-available");
              label.setAttribute('data-availability', 'available');
          } else {
              $(this).find('input').prop('disabled', true)
              $(this).addClass("option-not-available");
              label.setAttribute('data-availability', 'option-not-available');
          }
        });
      }
      /* end new sticky atc */

      item.find('.swatches-container__colors_selected-info-swatch').attr('data-unavailable', 'false');
      item.find('.swatch-element.option-not-available, .swatch-element.soldout').each(function () {
        const $swatchElement = $(this);
        const $tabContainer = $swatchElement.closest('.swatches-container__tab-outer-container');

        const colorClass = $swatchElement.find('label[role="button"]').attr('class')?.match(/color-[^\s]+/);

        if (colorClass) {
          const selector = `.swatches-container__colors_selected-info-swatch.${colorClass[0]}`;

          $tabContainer.find(selector).attr('data-unavailable', 'true');

          const overlayClass = $swatchElement.find('label[role="button"]').find('.swatch__not-available-overlay').hasClass('dark') ? 'dark' : 'light';

          if (overlayClass) {
            $tabContainer.find(selector).attr('data-color', overlayClass);
          }
        }
      });

      if (jQuery.inArray(initialValue, availableOptions) !== -1) {
          selector.val(initialValue)
      }
      // selector.trigger("change")
  };
  var linkOptionSelectors = function(product) {
      for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          optionsMapAll.root = optionsMapAll.root || [];
          optionsMapAll.root.push(variant.option1);
          optionsMapAll.root = Shopify.uniq(optionsMapAll.root);
          if (product.options.length > 1) {
              var key = variant.option1;
              optionsMapAll[key] = optionsMapAll[key] || [];
              optionsMapAll[key].push(variant.option2);
              optionsMapAll[key] = Shopify.uniq(optionsMapAll[key])
          }
          if (product.options.length === 3) {
              var key = variant.option1 + " / " + variant.option2;
              optionsMapAll[key] = optionsMapAll[key] || [];
              optionsMapAll[key].push(variant.option3);
              optionsMapAll[key] = Shopify.uniq(optionsMapAll[key])
          }
          if (variant.available) {
              optionsMap.root = optionsMap.root || [];
              optionsMap.root.push(variant.option1);
              optionsMap.root = Shopify.uniq(optionsMap.root);
              if (product.options.length > 1) {
                  var key = variant.option1;
                  optionsMap[key] = optionsMap[key] || [];
                  optionsMap[key].push(variant.option2);
                  optionsMap[key] = Shopify.uniq(optionsMap[key])
              }
              if (product.options.length === 3) {
                  var key = variant.option1 + " / " + variant.option2;
                  optionsMap[key] = optionsMap[key] || [];
                  optionsMap[key].push(variant.option3);
                  optionsMap[key] = Shopify.uniq(optionsMap[key])
              }
          }
      }
      updateOptionsInSelector(0);
      if (product.options.length > 1) updateOptionsInSelector(1);
      if (product.options.length === 3) updateOptionsInSelector(2);
      item.find(".single-option-selector:eq(0)").change(function() {
          updateOptionsInSelector(1);
          if (product.options.length === 3) updateOptionsInSelector(2);
          return !0
      });
      item.find(".single-option-selector:eq(1)").change(function() {
          if (product.options.length === 3) updateOptionsInSelector(2);
          return !0
      })
  }

    return init();    
};
